import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { applyFilters } from '@wordpress/hooks';
import Header from '../../common/Header';
import AiAssistant from "../../common/components/AIChatBubble/AiAssistant";
import './settings-menu.css';

const App = () => {
	/**
	 * Filters the default current menu.
	 *
	 * @since 1.0.0
	 * @param {string} defaultMenu The default menu.
	 */
	const defaultMenu = applyFilters(
		'easycommerce.settings.default.menu',
		'General'
	);

	const [currentMenu, setCurrentMenu] = useState(defaultMenu);
	const [showAPIModal, setShowAPIModal] = useState(false);
	const [user, setUser] = useState(null);

	useEffect(() => {
		const queryParams = new URLSearchParams(window.location.search);
		const menu = queryParams.get('menu');
		setCurrentMenu(menu || currentMenu);
	}, []);


	/**
	 * Filters the breadcrumbs.
	 *
	 * @since 1.0.0
	 * @param {Array} breadcrumbs The breadcrumbs array.
	 */
	const breadcrumbs = applyFilters(
		'easycommerce.settings.breadcrumbs',
		['Settings', currentMenu].map((item) =>
			item.split('-').map(
					(word) => word.charAt(0).toUpperCase() + word.slice(1)
				).join(' ')
		)
	);

	return (
		<>
			<Header
				breadcrumb={breadcrumbs}
				showAPIModal={showAPIModal}
				setShowAPIModal={setShowAPIModal}
				user={user}
				setUser={setUser}
			/>
			<AiAssistant user={user} setShowAPIModal={setShowAPIModal}/>
		</>
		
	);
};

const container = document.getElementById('easycommerce-settings-header');

const root = createRoot(container);
root.render(<App />);
